import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-listing-four',
  templateUrl: './listing-four.component.html',
  styleUrls: ['./listing-four.component.scss']
})
export class ListingFourComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
